module.exports = __webpack_public_path__ + "static/media/programacaoalapis-problema.45322b82.png";